import styles from "./Results.module.css";

const DeniedHIContent = (): JSX.Element => {
  return (
    <>
      <p className={styles.description} data-testid="denied-hi">
        Because of the number of folks on COBRA, we can’t offer you a quote
        right now. If the number of employees on COBRA decreases or the total
        number of employees increases email us at{" "}
        <a
          className="milo--link"
          target="_blank"
          rel="noreferrer"
          href="mailto: enrollment@justworks.com"
        >
          enrollment@justworks.com
        </a>{" "}
        to update your application.
      </p>

      <p className={styles.description}>
        <a
          className="milo--link"
          target="_blank"
          rel="noreferrer"
          href="https://help.justworks.com/hc/en-us/articles/360046094251-Carrier-Eligibility-Requirements"
        >
          Learn more
        </a>{" "}
        about our carrier eligibility requirements.
      </p>

      <p className={styles.description}>
        Up next, you can apply for robust HR tools, compliance resources, access
        to wellness and financial perks, and 24/7 customer support with{" "}
        <a
          className="milo--link"
          target="_blank"
          rel="noreferrer"
          href="https://justworks.com/plans/basic"
        >
          Basic plan
        </a>
        . The first step is to add your company details for workers'
        compensation insurance.
      </p>
    </>
  );
};

export default DeniedHIContent;
